module.exports = __webpack_public_path__ + "static/media/carpediemIconLogo.5e16695f.svg";